import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Alert, Box, Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../contexts/AuthContext";
import { AuthShell } from "./marketing/MarketingParts";

function parseHashParams() {
  const raw = window.location.hash || "";
  const s = raw.startsWith("#") ? raw.slice(1) : raw;
  const params = new URLSearchParams(s);
  return {
    token: params.get("token") || "",
    next: params.get("next") || "/sites",
  };
}

export default function GoogleAuthCallback() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { loginWithToken } = useContext(AuthContext);
  const [error, setError] = useState("");

  const { token, next } = useMemo(() => parseHashParams(), []);

  useEffect(() => {
    let alive = true;
    async function run() {
      try {
        if (!token) throw new Error("missing_token");
        await loginWithToken(token);
        if (!alive) return;
        nav(next || "/sites", { replace: true });
      } catch (_e) {
        if (!alive) return;
        setError("failed");
      }
    }
    run();
    return () => {
      alive = false;
    };
  }, [loginWithToken, nav, next, token]);

  return (
    <AuthShell title={t("mka_google_progress")}>
      <Box aria-live="polite" sx={{ display: "grid", gap: 2, justifyItems: "center" }}>
        {error ? (
          <>
            <Alert severity="error" sx={{ width: "100%" }}>
              {t("mka_google_fail")}
            </Alert>
            <Button component={Link} to="/login" variant="outlined" fullWidth>
              {t("mka_back_login")}
            </Button>
          </>
        ) : (
          <CircularProgress aria-label={t("mka_google_progress")} />
        )}
      </Box>
    </AuthShell>
  );
}
